// extracted by mini-css-extract-plugin
export default {"miniAppsPageButtonContainer":"MiniApps_miniAppsPageButtonContainer__ceS+V","miniAppsPageButton":"MiniApps_miniAppsPageButton__uaCwZ"};